/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleMapsLinks
 */
export interface GoogleMapsLinks {
    /**
     * 
     * @type {string}
     * @memberof GoogleMapsLinks
     */
    directionsUri?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMapsLinks
     */
    placeUri?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMapsLinks
     */
    photosUri?: string | null;
}

/**
 * Check if a given object implements the GoogleMapsLinks interface.
 */
export function instanceOfGoogleMapsLinks(value: object): value is GoogleMapsLinks {
    return true;
}

export function GoogleMapsLinksFromJSON(json: any): GoogleMapsLinks {
    return GoogleMapsLinksFromJSONTyped(json, false);
}

export function GoogleMapsLinksFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleMapsLinks {
    if (json == null) {
        return json;
    }
    return {
        
        'directionsUri': json['directionsUri'] == null ? undefined : json['directionsUri'],
        'placeUri': json['placeUri'] == null ? undefined : json['placeUri'],
        'photosUri': json['photosUri'] == null ? undefined : json['photosUri'],
    };
}

export function GoogleMapsLinksToJSON(json: any): GoogleMapsLinks {
    return GoogleMapsLinksToJSONTyped(json, false);
}

export function GoogleMapsLinksToJSONTyped(value?: GoogleMapsLinks | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'directionsUri': value['directionsUri'],
        'placeUri': value['placeUri'],
        'photosUri': value['photosUri'],
    };
}

